import { Route, Routes } from "@angular/router";
import { GetAnfrageValidationErrorsResolver } from "../resolver/anfrage/get-anfrage-validationerrors.resolver";
import { GetAnfrageContactDataResolver } from "../resolver/anfrage/get-anfrage-contact-data.resolver";
import { FragenProcessStepComponent } from "../features/anfrage/forms/fragen-process-step/fragen-process-step.component";
import { FragenResolver } from "../resolver/fragen/fragen.resolver";
import { AttachmentsProcessStepComponent } from "../features/anfrage/forms/attachments-process-step/attachments-process-step.component";
import { ScheduleDataProcessStepComponent } from "../features/anfrage/forms/schedule-data-process-step/schedule-data-process-step.component";
import { GetAnfrageReportDocumenttypesResolver } from "../resolver/report/get-anfrage-report-documenttypes.resolver";
import { GetAnfrageReportAttachmentsResolver } from "../resolver/report/get-anfrage-report-attachments.resolver";
import { GetAnfrageReportScheduleDataResolver } from "../resolver/report/get-anfrage-report-schedule.resolver";
import { AnfrageReportDetailComponent } from "../features/reports/anfrage-report-detail/anfrage-report-detail.component";
import { GetAnfrageReportByIdResolver } from "../resolver/report/get-anfrage-report-by-id.resolver";
import { BaseRoutingFactory } from "./base-routing.factory";
import { DataprotectionProcessStepComponent } from "../forms/dataprotection-process-step/dataprotection-process-step.component";

export class ReportRoutingFactory extends BaseRoutingFactory
{
    private readonly coreReportRoute: Routes = [
        {
            path: ':scope/:id/:reportid',
            component: AnfrageReportDetailComponent,
            resolve: {
                anfrage: GetAnfrageReportByIdResolver
            },
            children: [
            {
                path: 'attachments/:abschnittid',
                component: AttachmentsProcessStepComponent,
                resolve: {
                    contactData: GetAnfrageContactDataResolver,
                    documenttypes: GetAnfrageReportDocumenttypesResolver,
                    attachments: GetAnfrageReportAttachmentsResolver
                },
                runGuardsAndResolvers: 'paramsOrQueryParamsChange'
            },
            {
                path: 'schedule/:abschnittid',
                component: ScheduleDataProcessStepComponent,
                resolve: {
                    scheduleData: GetAnfrageReportScheduleDataResolver
                }
            },
            {
                path: 'questions/:abschnittid',
                component: FragenProcessStepComponent,
                resolve: {
                    fragen: FragenResolver
                },
                runGuardsAndResolvers: 'paramsOrQueryParamsChange'
            },
            {
                path: 'dataprotection',
                component: DataprotectionProcessStepComponent,
                resolve: {
                    errors: GetAnfrageValidationErrorsResolver
                },
            },
            ]
        }
    ];

    public create(): Routes
    {
        const coreRoute = this.coreRoute;

        return coreRoute;
    }

    protected get coreRoute(): Routes {
        return this.coreReportRoute;
    }

    protected registerChild(coreRoute: Routes, route: Route) {        
        const formRoutes = coreRoute![0].children!;
        const foundIndex = formRoutes?.findIndex(formRoute => formRoute.path === route.path);
        if (foundIndex >= 0) {
            formRoutes[foundIndex] = route;
            return;
        }
        else {
            coreRoute![0].children!.push(route);
        }
    } 
}